import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  validateCateringCustomer,
  validateFBZCustomer,
} from '../validations/customerValidation';
import { showErrorToast } from '../../../utils/toastHelper';
import BasicTimePicker from '../../../components/BasicTimePicker';
import { AsyncPaginate } from 'react-select-async-paginate';
import {
  fetchCustomerGroups,
  generateProductCode,
} from '../services/customersService';
export default function EditCustomerModal({
  customer,
  isOpen,
  onClose,
  handleEditCustomerSubmit,
  areas,
  districts,
  paymentMethods,
  logisticLines,
  customerGroups,
  type,
}) {
  const { t } = useTranslation('Customer');

  const [formData, setFormData] = useState({
    code: '',
    customer_group: null,
    name: '',
    delivery_address: '',
    // contact_persons: [{ name: "", contact: "" }],
    contact_name: '',
    contact_phone: '',
    email: '',
    area: null,
    district: null,
    logistic_line: null,
    payment_method: null,
    earliest_delivery_time: '',
    latest_delivery_time: '',
  });
  const [earliestDeliveryStartTime, setEarliestDeliveryStartTime] =
    useState('');
  const [earliestDeliveryEndTime, setEarliestDeliveryEndTime] = useState('');
  const [latestDeliveryStartTime, setLatestDeliveryStartTime] = useState('');
  const [latestDeliveryEndTime, setLatestDeliveryEndTime] = useState('');
  const [codeError, setCodeError] = useState(false);

  const resetForm = (e) => {
    setEarliestDeliveryStartTime('');
    setEarliestDeliveryEndTime('');
    setLatestDeliveryStartTime('');
    setLatestDeliveryEndTime('');
    setFormData({
      code: '',
      customer_group: null,
      name: '',
      delivery_address: '',
      contact_name: '',
      contact_phone: '',
      email: '',
      area: null,
      district: null,
      logistic_line: null,
      payment_method: null,
      earliest_delivery_time: '',
      latest_delivery_time: '',
    });
  };

  useEffect(() => {
    const modalElement = document.getElementById('edit-customer');
    const modalInstance = new window.bootstrap.Modal(modalElement, {
      backdrop: 'static',
      keyboard: false,
    });

    if (isOpen) {
      modalInstance.show();
    } else {
      modalInstance.hide();
    }
    return () => {
      modalInstance.hide();
    };
  }, [isOpen]);
  const fetchCode = async () => {
    setCodeError(false);
    const response = await generateProductCode();
    if (response.success && response.code) {
      setFormData((prevData) => ({
        ...prevData,
        code: response.code,
      }));
    } else {
      setCodeError(true);
    }
  };
  useEffect(() => {
    const shouldGenerateCode =
      isOpen &&
      type === 'FBZ' &&
      (!customer?.code || customer.code.trim() === '');

    if (shouldGenerateCode) {
      fetchCode();
    }
  }, [isOpen, customer, type]);
  useEffect(() => {
    if (customer) {
      setFormData({
        code: customer?.code,
        customer_group: customer?.customer_group,
        name: customer?.name,
        delivery_address: customer?.delivery_address,
        // contact_persons: [{ name: "", contact: "" }],
        contact_name: customer?.contact_name,
        contact_phone: customer?.contact_phone,
        email: customer.email,
        area: customer.area,
        district: customer?.district,
        logistic_line: customer?.logistic_line,
        payment_method: customer?.payment_method,
        earliest_delivery_time: customer.earliest_delivery_time,
        latest_delivery_time: customer.latest_delivery_time,
      });

      if (customer.earliest_delivery_time) {
        const parts = customer.earliest_delivery_time
          .split('-')
          .map((part) => part.trim());

        setEarliestDeliveryStartTime(parts[0]);

        if (parts.length > 1) {
          setEarliestDeliveryEndTime(parts[1]);
        }
      }
      if (customer.latest_delivery_time) {
        const parts = customer.latest_delivery_time
          .split('-')
          .map((part) => part.trim());

        setLatestDeliveryStartTime(parts[0]);

        if (parts.length > 1) {
          setLatestDeliveryEndTime(parts[1]);
        }
      }
    }
  }, [customer]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  // const handleEarliestDeliveryTimeChange = (e) => {
  //   const { name, value } = e.target;
  const handleEarliestDeliveryTimeChange = (time, name = '') => {
    let value;
    if (!time) {
      value = time;
    } else {
      value = time.format('HH:mm');
    }

    if (name === 'start_time') {
      setEarliestDeliveryStartTime(value);
      setEarliestDeliveryEndTime(''); // Reset end time when start time changes
      setFormData((prevData) => ({
        ...prevData,
        earliest_delivery_time: value ? value : '', // Set only start time if no end time
      }));
    }

    if (name === 'end_time') {
      if (earliestDeliveryStartTime && value < earliestDeliveryStartTime) {
        showErrorToast(t('END_TIME_CANNOT_BE_EARLIER'));
        return;
      }
      setEarliestDeliveryEndTime(value);
      if (earliestDeliveryStartTime) {
        setFormData((prevData) => ({
          ...prevData,
          earliest_delivery_time: `${earliestDeliveryStartTime}-${value}`, // Combine both times
        }));
      }
    }
  };
  // const handleLatestDeliveryTimeChange = (e) => {
  //   const { name, value } = e.target;
  const handleLatestDeliveryTimeChange = (time, name = '') => {
    let value;
    if (!time) {
      value = time;
    } else {
      value = time.format('HH:mm');
    }
    if (name === 'start_time') {
      setLatestDeliveryStartTime(value);
      setLatestDeliveryEndTime('');
      setFormData((prevData) => ({
        ...prevData,
        latest_delivery_time: value ? value : '',
      }));
    }

    if (name === 'end_time') {
      if (latestDeliveryStartTime && value < latestDeliveryStartTime) {
        showErrorToast(t('END_TIME_CANNOT_BE_EARLIER'));
        return;
      }
      setLatestDeliveryEndTime(value);
      if (latestDeliveryStartTime) {
        setFormData((prevData) => ({
          ...prevData,
          latest_delivery_time: `${latestDeliveryStartTime}-${value}`,
        }));
      }
    }
  };

  const handleAreaChange = (e) => {
    const selectedArea = areas.find((area) => area.id === e.target.value);

    setFormData((prevData) => ({
      ...prevData,
      area: selectedArea || null,
    }));
  };
  const handleDistrictChange = (e) => {
    const selectedDistrict = districts.find(
      (district) => district.id === e.target.value
    );

    const selectedArea = areas.find(
      (area) => area.id === selectedDistrict.area_id
    );

    setFormData((prevData) => ({
      ...prevData,
      district: selectedDistrict || null,
      area: selectedArea || null,
    }));
  };
  const handlePaymentMethodChange = (e) => {
    const selectedPaymentMethod = paymentMethods.find(
      (payment_method) => payment_method.id === e.target.value
    );

    setFormData((prevData) => ({
      ...prevData,
      payment_method: selectedPaymentMethod || null,
    }));
  };
  const handleLogisticLineChange = (e) => {
    const selectedLogisticLine = logisticLines.find(
      (logistic_line) => logistic_line.id === e.target.value
    );

    setFormData((prevData) => ({
      ...prevData,
      logistic_line: selectedLogisticLine || null,
    }));
  };
  const handleCustomerGroupChange = (selectedOption) => {
    setFormData((prevData) => ({
      ...prevData,
      customer_group: selectedOption ? selectedOption.group : null,
    }));
  };

  // Add customer group load options function
  const customerGroupLoadOptions =
    (labelType = 'code') =>
    async (inputValue, loadedOptions, { page }) => {
      const per_page = 50;
      const query = { page, per_page, search: inputValue, category: type };
      const customerGroupResponse = await fetchCustomerGroups(query);

      // setGroupNames((prev) => [
      //   ...prev,
      //   ...(customerGroupResponse?.customer_groups || []),
      // ]);

      const newOptions = customerGroupResponse.customer_groups?.map(
        (group) => ({
          value: group.id,
          label:
            labelType === 'code'
              ? `${group.code}`
              : labelType === 'group'
                ? `${group.group}`
                : `${group.code} - ${group.group}`,
          group: group,
        })
      );

      return {
        options: newOptions,
        hasMore:
          customerGroupResponse.pagination.current_page <
          customerGroupResponse.pagination.last_page,
        additional: {
          page: page + 1,
        },
      };
    };

  const handleSubmit = async () => {
    let validationResult;
    if (type === 'FBZ') {
      validationResult = await validateFBZCustomer(formData);
    } else {
      validationResult = await validateCateringCustomer(formData);
    }
    if (!validationResult) {
      return;
    }
    if (handleEditCustomerSubmit) {
      const response = await handleEditCustomerSubmit(formData, customer.id);
      if (response?.success) {
        resetForm();
      }
    }
  };

  return (
    <div
      className="modal fade order-ui-setting"
      id="edit-customer"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="staticBackdropLabel">
              {type === 'FBZ'
                ? t('EDITFBZCUSTOMER')
                : t('EDITCATERINGCUSTOMER')}
            </h1>
            <button
              type="button"
              className="btn-close"
              onClick={() => {
                resetForm();
                onClose('edit');
              }}
            ></button>
          </div>
          <div className="modal-body">
            <section className="first">
              <div className="row">
                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <AsyncPaginate
                      value={
                        formData?.customer_group?.id
                          ? {
                              value: formData.customer_group.id,
                              label: formData.customer_group.code,
                            }
                          : null
                      }
                      loadOptions={customerGroupLoadOptions('code')}
                      onChange={(selectedOption) => {
                        handleCustomerGroupChange(selectedOption);
                      }}
                      placeholder={t('SELECTCUSTOMERGROUPCODE')}
                      isClearable
                      additional={{ page: 1 }}
                      className="w-100"
                      styles={{
                        control: (base) => {
                          const width = window.innerWidth;
                          let height = '54px'; // default
                          let fontSize = '16px';

                          if (width <= 1760) {
                            height = '45px';
                            fontSize = '15px';
                          }
                          if (width <= 1660) {
                            height = '43px';
                            fontSize = '13px';
                          }
                          if (width <= 1024) {
                            height = '43px';
                            fontSize = '13px';
                          }

                          return {
                            ...base,
                            minHeight: height,
                            fontSize: fontSize,
                            height: height,
                          };
                        },
                        valueContainer: (base) => {
                          const width = window.innerWidth;
                          let height = '54px';
                          let fontSize = '16px';

                          if (width <= 1760) {
                            height = '45px';
                            fontSize = '15px';
                          }
                          if (width <= 1660) {
                            height = '43px';
                            fontSize = '13px';
                          }
                          if (width <= 1024) {
                            height = '43px';
                            fontSize = '13px';
                          }

                          return {
                            ...base,
                            height: height,
                            padding: '0 8px',
                          };
                        },
                        input: (base) => ({
                          ...base,
                          margin: 0,
                          padding: 0,
                        }),
                        indicatorsContainer: (base) => {
                          const width = window.innerWidth;
                          let height = '54px';
                          let fontSize = '16px';

                          if (width <= 1760) {
                            height = '45px';
                            fontSize = '15px';
                          }
                          if (width <= 1660) {
                            height = '43px';
                            fontSize = '13px';
                          }
                          if (width <= 1024) {
                            height = '43px';
                            fontSize = '13px';
                          }

                          return {
                            ...base,
                            height: height,
                            fontSize: fontSize,
                          };
                        },
                      }}
                    />
                    {/* <label className="did-floating-label">
                      {t('CUSTOMERGROUPCODE')}
                    </label> */}
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <AsyncPaginate
                      value={
                        formData?.customer_group?.id
                          ? {
                              value: formData.customer_group.id,
                              label: formData.customer_group.group,
                            }
                          : null
                      }
                      loadOptions={customerGroupLoadOptions('group')}
                      onChange={(selectedOption) => {
                        handleCustomerGroupChange(selectedOption);
                      }}
                      placeholder={t('SELECTCUSTOMERGROUPNAME')}
                      isClearable
                      additional={{ page: 1 }}
                      className="w-100"
                      styles={{
                        control: (base) => {
                          const width = window.innerWidth;
                          let height = '54px'; // default
                          let fontSize = '16px';

                          if (width <= 1760) {
                            height = '45px';
                            fontSize = '15px';
                          }
                          if (width <= 1660) {
                            height = '43px';
                            fontSize = '13px';
                          }
                          if (width <= 1024) {
                            height = '43px';
                            fontSize = '13px';
                          }

                          return {
                            ...base,
                            minHeight: height,
                            fontSize: fontSize,
                            height: height,
                          };
                        },
                        valueContainer: (base) => {
                          const width = window.innerWidth;
                          let height = '54px';
                          let fontSize = '16px';

                          if (width <= 1760) {
                            height = '45px';
                            fontSize = '15px';
                          }
                          if (width <= 1660) {
                            height = '43px';
                            fontSize = '13px';
                          }
                          if (width <= 1024) {
                            height = '43px';
                            fontSize = '13px';
                          }
                          return {
                            ...base,
                            height: height,
                            fontSize: fontSize,
                            padding: '0 8px',
                          };
                        },
                        input: (base) => ({
                          ...base,
                          margin: 0,
                          padding: 0,
                        }),
                        indicatorsContainer: (base) => {
                          const width = window.innerWidth;
                          let height = '54px';
                          let fontSize = '16px';

                          if (width <= 1760) {
                            height = '45px';
                            fontSize = '15px';
                          }
                          if (width <= 1660) {
                            height = '43px';
                            fontSize = '13px';
                          }
                          if (width <= 1024) {
                            height = '43px';
                            fontSize = '13px';
                          }

                          return {
                            ...base,
                            height: height,
                            fontSize: fontSize,
                          };
                        },
                      }}
                    />
                    {/* <label className="did-floating-label">
                      {t('CUSTOMERGROUPNAME')}
                    </label> */}
                  </div>
                </div>

                {/* {type.toUpperCase() === 'CATERING' && (
                  <> */}
                <div className="col-sm-4">
                  <div className="did-floating-label-content">
                    <input
                      className="did-floating-input"
                      type="text"
                      name="code"
                      value={
                        type === 'FBZ' && !formData.code
                          ? codeError
                            ? '' // show blank if generation failed
                            : t('GENERATINGCODE') + '...'
                          : formData.code
                      }
                      disabled
                    />
                    <label className="did-floating-label">
                      {t('CUSTOMERCODE')}
                    </label>
                    {/* Show retry button if code generation failed */}
                    {type === 'FBZ' && codeError && (
                      <button
                        type="button"
                        onClick={fetchCode}
                        style={{
                          position: 'absolute',
                          right: '10px',
                          top: '8px',
                          background: 'transparent',
                          border: 'none',
                          cursor: 'pointer',
                          color: 'red',
                        }}
                        title={t('RETRY')}
                      >
                        🔄
                      </button>
                    )}
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="did-floating-label-content">
                    <input
                      className="did-floating-input"
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder=" "
                    />
                    <label className="did-floating-label">
                      {t('CUSTOMERNAME')}
                    </label>
                  </div>
                </div>
                {/* </>
                )} */}
                <div className="col-sm-4">
                  <div className="did-floating-label-content">
                    <input
                      className="did-floating-input"
                      type="text"
                      name="delivery_address"
                      value={formData.delivery_address}
                      onChange={handleChange}
                      // onChange={(e) => handleDeliveryAddressChange(index, e)}
                      placeholder=" "
                    />
                    <label className="did-floating-label">
                      {t('DELIVERYADDRESS')} <span className="required">*</span>
                    </label>
                  </div>
                </div>

                <div className="col-sm-4">
                  <div className="did-floating-label-content">
                    <input
                      className="did-floating-input"
                      type="text"
                      name="contact_name"
                      value={formData.contact_name}
                      onChange={handleChange}
                      placeholder=" "
                    />
                    <label className="did-floating-label">
                      {t('CONTACTPERSONNAME')}{' '}
                      <span className="required">*</span>
                    </label>
                  </div>
                </div>

                <div className="col-sm-4">
                  <div className="did-floating-label-content">
                    <input
                      className="did-floating-input"
                      type="text"
                      name="contact_phone"
                      value={formData.contact_phone}
                      onChange={handleChange}
                      placeholder=" "
                    />
                    <label className="did-floating-label">
                      {t('CONTACTPHONENO')}
                      <span className="required">*</span>
                    </label>
                  </div>
                </div>

                <div className="col-sm-4">
                  <div className="did-floating-label-content">
                    <input
                      className="did-floating-input"
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder=" "
                    />
                    <label className="did-floating-label">
                      {t('CUSTOMEREMAIL')}
                    </label>
                  </div>
                </div>

                <div className="col-sm-4">
                  <div className="did-floating-label-content">
                    <select
                      className="did-floating-select"
                      name="area"
                      value={formData?.area?.id}
                      onChange={handleAreaChange}
                    >
                      <option value="">{t('SELECTAREA')}</option>
                      {areas.map((area) => (
                        <option key={area.id} value={area.id}>
                          {area.name}
                        </option>
                      ))}
                    </select>
                    <label className="did-floating-label">
                      {t('AREA')} <span className="required">*</span>
                    </label>
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="did-floating-label-content">
                    <select
                      className="did-floating-select"
                      name="district"
                      value={formData?.district?.id}
                      onChange={handleDistrictChange}
                    >
                      <option value="">{t('SELECTDISTRICT')}</option>
                      {[
                        ...(formData?.area?.id
                          ? districts.filter(
                              (d) => d.area_id === formData.area.id
                            )
                          : districts),
                        // Append selected district if it's not in the filtered list (for previous orders update, replace this with the version in add customer modal in future)
                        ...(formData?.district?.id &&
                        !(
                          formData?.area?.id
                            ? districts.filter(
                                (d) => d.area_id === formData.area.id
                              )
                            : districts
                        ).some((d) => d.id === formData.district.id)
                          ? [formData.district]
                          : []),
                      ].map((district) => (
                        <option key={district.id} value={district.id}>
                          {district.name}
                        </option>
                      ))}
                    </select>
                    <label className="did-floating-label">
                      {t('DISTRICT')} <span className="required">*</span>
                    </label>
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="did-floating-label-content">
                    <select
                      className="did-floating-select"
                      name="logistic_line"
                      value={formData?.logistic_line?.id}
                      onChange={handleLogisticLineChange}
                    >
                      <option value="">{t('SELECTLOGISTICLINE')}</option>
                      {logisticLines.map((logistic_line) => (
                        <option key={logistic_line.id} value={logistic_line.id}>
                          {logistic_line.name}
                        </option>
                      ))}
                    </select>
                    <label className="did-floating-label">
                      {t('LOGISTICLINE')} <span className="required">*</span>
                    </label>
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="did-floating-label-content">
                    <select
                      className="did-floating-select"
                      name="payment_method"
                      value={formData?.payment_method?.id}
                      onChange={handlePaymentMethodChange}
                    >
                      <option value="">{t('SELECTPAYMENTMETHOD')}</option>
                      {paymentMethods.map((payment_method) => (
                        <option
                          key={payment_method.id}
                          value={payment_method.id}
                        >
                          {payment_method.name}
                        </option>
                      ))}
                    </select>
                    <label className="did-floating-label">
                      {t('PAYMENTMETHOD')} <span className="required">*</span>
                    </label>
                  </div>
                </div>

                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <BasicTimePicker
                      name="start_time"
                      value={earliestDeliveryStartTime || null}
                      placeholder={t('EARLIESTDELIVERYTIMEFROM')}
                      onChange={handleEarliestDeliveryTimeChange}
                    />
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <BasicTimePicker
                      name="end_time"
                      value={earliestDeliveryEndTime || null}
                      disabled={!earliestDeliveryStartTime}
                      placeholder={t('EARLIESTDELIVERYTIMETO')}
                      onChange={handleEarliestDeliveryTimeChange}
                    />
                  </div>
                </div>

                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <BasicTimePicker
                      name="start_time"
                      value={latestDeliveryStartTime || null}
                      placeholder={t('LATESTDELIVERYTIMEFROM')}
                      onChange={handleLatestDeliveryTimeChange}
                    />
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <BasicTimePicker
                      name="end_time"
                      value={latestDeliveryEndTime || null}
                      disabled={!latestDeliveryStartTime}
                      placeholder={t('LATESTDELIVERYTIMEFROM')}
                      onChange={handleLatestDeliveryTimeChange}
                    />
                  </div>
                </div>
              </div>
              <div className="bottom-button">
                <button
                  className="cancel"
                  onClick={() => {
                    resetForm();
                    onClose('edit');
                  }}
                >
                  {t('CANCEL')}
                </button>
                <button className="save" onClick={handleSubmit}>
                  {t('SAVE')}
                </button>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
